import React, { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import { StyledTabs, StyledTab, TabsHeader } from "@rentablo/components";
import { SecuritiesChartType } from "./types";

interface ChartTypeTabsProps {
  chartType: SecuritiesChartType;
  onChartTypeChange?: (value: SecuritiesChartType) => void;
  // Sits at the right end of the tab line, above its bottom border.
  action?: ReactNode;
}

export const ChartTypeTabs = ({
  chartType,
  onChartTypeChange,
  action,
}: ChartTypeTabsProps) => {
  const { t } = useTranslation();

  const handleTabChange = (
    _event: React.SyntheticEvent,
    newValue: SecuritiesChartType
  ) => {
    if (onChartTypeChange) {
      onChartTypeChange(newValue);
    }
  };

  return (
    <TabsHeader centered={false}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        gap={2}
        data-testid="chart-type-tab-line"
      >
        <StyledTabs value={chartType} onChange={handleTabChange}>
          <StyledTab
            label={t("securitiesChart.typeSwitcher.valuation")}
            value="valuation"
          />
          <StyledTab
            label={t("securitiesChart.typeSwitcher.performance")}
            value="performance"
          />
        </StyledTabs>
        {action}
      </Box>
    </TabsHeader>
  );
};
